import type {
  Feature as FeatureInterface,
  OfferImage
} from 'src/types/subscription';
import { DynamicObject } from 'src/utils/commonTypes';
import { TAG_NAME } from 'src/utils/constants/TagNameConstants';
import { getSubsImageUrl } from 'src/utils/SubscriptionHelper/SubscriptionHelper';

import { autoHeight, Container, Icon } from './styles';
import { useAppStore } from '../../../../hooks/useAppStore';

const IconMapping: DynamicObject = {
  CMS_PLAN_4K_AUDIO_ICON: 'audio',
  CMS_PLAN_4K_VIDEO_ICON: 'video',
  CMS_PLAN_4K_DEVICES_ICON: 'screen',
  CMS_PLAN_MOBILE_VIDEO_ICON: 'video',
  CMS_PLAN_MOBILE_AUDIO_ICON: 'audio',
  CMS_PLAN_MOBILE_DEVICES_ICON: 'screen',
  CMS_PLAN_HD_VIDEO_ICON: 'video',
  CMS_PLAN_HD_AUDIO_ICON: 'audio',
  CMS_PLAN_HD_DEVICES_ICON: 'screen'
};
/**
 * Return the asset mapped from BE to public directory
 * */
const getIconSrc = (
  deviceWidth: number,
  icon?: OfferImage,
  iconName?: string
) => {
  return (
    getSubsImageUrl(deviceWidth, TAG_NAME.SUBS_FEATURE_ICON, icon) ||
    `/webapp-assets/images/pack_${
      IconMapping[iconName as keyof typeof IconMapping] ?? 'fallback'
    }_icon.svg?ver=${process.env.APP_VERSION}`
  );
};

interface ItemProps extends FeatureInterface {}

const Feature = (props: {
  item: ItemProps;
  active: boolean;
  isFeature?: boolean;
}) => {
  const { appConfig: { deviceWidth = 768 } = {} } = useAppStore();
  return (
    <Container data-test-id={`feature_${props.item.icon}`}>
      <Icon
        src={getIconSrc(deviceWidth, props.item.iconSrc, props.item.icon)}
        active={props.active}
        css={[props?.isFeature && autoHeight]}
      />
    </Container>
  );
};
export default Feature;
